<script setup lang="ts">
import { useTimesheetStore } from '@/stores/timesheets';
import { useRosterStore } from '@/stores/rosters';
import BreaksList from './BreaksList.vue';

const timesheets = useTimesheetStore();
const rosters = useRosterStore();

defineProps<{
  editBreaksModal?: boolean;
}>();

function showEditBreakForm(breakId: number) {
  emit('showEditBreakForm', breakId);
}

const emit = defineEmits<{
  (e: 'showEditBreakForm', breakId: number): void;
}>();
</script>

<template>
  <div class="break-details">
    <div
      v-if="timesheets.isOnShift && !rosters.getRosterForActiveTimesheet()"
      :class="editBreaksModal ? `__edit-breaks` : `__breaks`"
    >
      <img
        v-if="!editBreaksModal"
        class="__icon-image"
        src="../assets/images/cafe-grey.png"
      />
      <BreaksList
        @showEditBreakForm="showEditBreakForm"
        :editBreaksModal="editBreaksModal"
        :allBreaks="true"
        :breaks="timesheets.getBreaks()"
      ></BreaksList>
    </div>
    <div
      v-if="
        rosters.getRosterForActiveTimesheet() ||
        (!timesheets.isOnShift && rosters.getNextRosterForActiveUser())
      "
      :class="editBreaksModal ? `__edit-breaks` : `__breaks`"
    >
      <img
        v-if="!editBreaksModal"
        class="__icon-image"
        src="../assets/images/cafe-grey.png"
      />
      <div>
        <BreaksList
          @showEditBreakForm="showEditBreakForm"
          :editBreaksModal="editBreaksModal"
          :scheduledBreaks="!timesheets.isOnShift"
          :allBreaks="timesheets.isOnShift"
          :breaks="
            timesheets.isOnShift
              ? timesheets.getBreaks()
              : rosters.getScheduledBreaks()
          "
        ></BreaksList>
      </div>
    </div>
  </div>
</template>

<style scoped>
.__breaks {
  display: flex;
  margin-left: 14px;
}
.__icon-image {
  width: 18px;
  height: 18px;
  margin: 7px 18.6px 5px 1.5px;
}
.break-details:has(div) {
  padding-bottom: 5px;
}
</style>

<style>
.__edit-details .__breaks {
  margin: 2px 0 0 0;
}
</style>
